import * as url from "../url.helper";

import { post } from "../api.helper";

export const addPermission = data => post(url.ADD_PERMISSION, data);

export const getPermission = data => post(url.GET_PERMISSION, data);

export const getOnePermission = data => post(url.GET_ONE_PERMISSION, data);

export const editPermission = data => post(url.EDIT_PERMISSION, data);

export const getModules = data => post(url.GET_MODULES, data);

